// My Pets helpers (same rules as the customer app): age text and the
// products picked for a pet.
export const SPECIES = [
  { value: "dog", label: "Dog" },
  { value: "cat", label: "Cat" },
  { value: "bird", label: "Bird" },
  { value: "fish", label: "Fish" },
  { value: "rabbit", label: "Rabbit" },
  { value: "small", label: "Hamster / guinea pig" },
  { value: "other", label: "Other" },
];
export const SPECIES_LABEL = { dog: "Dog", cat: "Cat", bird: "Bird", fish: "Fish", rabbit: "Rabbit", small: "Small pet", other: "Pet" };
export const BREED_EXAMPLE = { dog: "e.g. Labrador Retriever", cat: "e.g. Persian", bird: "e.g. Budgie", fish: "e.g. Goldfish", rabbit: "e.g. Holland Lop", small: "e.g. Syrian hamster", other: "e.g. Tortoise" };
// A pet → the products' "for" (pet type).
export const PET_TYPE_OF = { dog: "Dogs", cat: "Cats", bird: "Birds", fish: "Fish", rabbit: "Rabbits", small: "Small Pets" };

export function ageText(months) {
  if (months == null) return "";
  if (months < 1) return "Under a month";
  if (months < 12) return `${months} month${months === 1 ? "" : "s"}`;
  const y = Math.floor(months / 12);
  const m = months % 12;
  return `${y} year${y === 1 ? "" : "s"}${m && y < 3 ? ` ${m} mo` : ""}`;
}

/** young / adult / senior */
export function lifeStage(pet) {
  const m = pet?.age_months;
  if (m == null) return "adult";
  if (m < 12) return "young";
  if (m >= (pet.species === "cat" ? 120 : 84)) return "senior";
  return "adult";
}

const STAGE_WORDS = {
  young: /pupp|kitten|junior|starter/i,
  adult: /adult/i,
  senior: /senior|mature|7\+|ageing|aging/i,
};

/** Products for this pet, best matches first: right animal, right life stage. */
export function picksFor(pet, products) {
  const kind = PET_TYPE_OF[pet.species] || null;
  const stage = lifeStage(pet);
  const other =
    stage === "young" ? [STAGE_WORDS.adult, STAGE_WORDS.senior] : stage === "senior" ? [STAGE_WORDS.young] : [STAGE_WORDS.young, STAGE_WORDS.senior];
  return (products || [])
    .filter((p) => p.best_offer || p.size_count > 1)
    .filter((p) => !kind || p.pet_type === kind || p.pet_type === "All Pets" || !p.pet_type)
    .filter((p) => !other.some((re) => re.test(p.name)))
    .map((p) => ({ p, score: (kind && p.pet_type === kind ? 2 : 0) + (STAGE_WORDS[stage].test(p.name) ? 3 : 0) }))
    .sort((a, b) => b.score - a.score)
    .slice(0, 12)
    .map((x) => x.p);
}
